module.exports = __webpack_public_path__ + "img/customer-service.3df887cf.webp";